import React, { useState, useEffect } from "react";
import { useField, useFormikContext } from "formik";
import DatePicker from "react-datepicker";
import { get } from "lodash";

const DatePickerField = ({ ...props }) => {
  const { label, required, readOnly } = props;
  const [field, { value }, { setValue }] = useField(props);
  const { name } = field;
  const { errors, touched } = useFormikContext();
  const [fieldErrors, setFieldErrors] = useState(null);

  useEffect(() => {
    const fieldErrors = get(errors, name);
    setFieldErrors(fieldErrors && get(touched, name) ? fieldErrors : null);
  }, [name, errors, touched]);

  if (!label) {
    return (
      <DatePicker
        {...field}
        {...props}
        selected={(value && new Date(value)) || ""}
        onChange={(val) => setValue(val)}
      />
    );
  }

  return (
    <div>
      <label htmlFor={name}>
        <span
          className={`inline-block ${
            readOnly && "text-medium-gray font-body-bold "
          }`}
        >
          {label}
          {required && !readOnly && (
            <>
              {" "}
              <span className="text-sm required" aria-hidden>
                *
              </span>
              <span className="sr-only">(required)</span>
            </>
          )}
        </span>
        <DatePicker
          {...field}
          {...props}
          selected={(value && new Date(value)) || ""}
          className="form-input w-full"
          onChange={(val) => setValue(val)}
        />
      </label>
      {fieldErrors && (
        <div className="text-sm text-red mt-1">{fieldErrors}</div>
      )}
    </div>
  );
};

export default DatePickerField;
